var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"admin-panel"},[_c('div',{staticClass:"admin-panel-body"},[(_vm.page === 'dashboard')?_c('admin-dashboard'):_vm._e(),(_vm.page === 'company')?_c('admin-company'):_vm._e(),(_vm.page === 'companies')?_c('admin-companies'):_vm._e(),(_vm.page === 'jobs')?_c('admin-jobs'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }